import { toast } from 'react-toastify';

const useToast = () => {
  const successToast = (message: string) => {
    toast.success(message, {
      toastId: message,
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const errorToast = (message: string) => {
    toast.error(message || 'Erro desconhecido', {
      toastId: message,
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const warningToast = (message: string) => {
    toast.warning(message, {
      toastId: message,
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const infoToast = (message: string) => {
    toast.info(message, {
      toastId: message,
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  return {
    successToast,
    errorToast,
    warningToast,
    infoToast,
  };
};

export default useToast;
